import React, { useState, useEffect } from "react";
import { query, collection } from "firebase/firestore";

import SkeletonLoader from "components/skeletonLoader";
import TeamForm from "components/teamForm";
import {
  OVERALL_MATCHES,
  OVERALL_WINS,
  OVERALL_DRAWS,
  OVERALL_LOST,
  OVERALL_SCORED,
  OVERALL_CONCEDED,
  OVERALL_GOAL_DIFFERENCE,
} from "utils/constants";
import { classNames } from "utils/utils";
import { useFirestore, useFirestoreCollectionData } from "reactfire";

const LeagueTable = ({ leagueId, seasonId, showLogos, highlightedTeams }) => {
  const [leagueTeams, setLeagueTeams] = useState([]);
  const firestore = useFirestore();

  const teamsCollection = collection(
    firestore,
    "leagues/" + leagueId + "/seasons/" + seasonId + "/teams"
  );
  const teamsQuery = query(teamsCollection);
  const { status: teamsStatus, data: teamsData } =
    useFirestoreCollectionData(teamsQuery);

  useEffect(() => {
    if (teamsData) {
      setLeagueTeams(teamsData);
    }
  }, [teamsData]);

  const tableStats = [
    OVERALL_MATCHES,
    OVERALL_WINS,
    OVERALL_DRAWS,
    OVERALL_LOST,
    OVERALL_SCORED,
    OVERALL_CONCEDED,
    OVERALL_GOAL_DIFFERENCE,
  ];

  const secondaryStats = [OVERALL_WINS, OVERALL_DRAWS, OVERALL_LOST];
  //

  if (teamsStatus !== "success") {
    return (
      <div className="flex flex-col">
        <SkeletonLoader type={"emptyTableRow"} amount={3} />
      </div>
    );
  }

  const list = leagueTeams
    .sort(function (x, y) {
      if (x.statistics?.position && y.statistics?.position) {
        return x.statistics.position - y.statistics.position;
      } else return x.name.localeCompare(y.name);
    })
    .map((team) => {
      const statsList = team.statistics?.details
        .sort((a, b) => a.type_id - b.type_id)
        .filter((stat) => tableStats.includes(stat.type_id))
        .map((stat) => {
          return (
            <div className="flex flex-col justify-center">
              <span
                className={classNames(
                  secondaryStats.includes(stat.type_id)
                    ? "w-4 xs:w-6 text-gray-500"
                    : "w-6 xs:w-8",
                  "flex justify-center "
                )}
              >
                {stat.value}
              </span>
            </div>
          );
        });

      return (
        <div
          key={team.id}
          className={classNames(
            highlightedTeams.length && highlightedTeams.includes(team.id)
              ? "bg-gray-100"
              : "",
            "flex flex-row w-full text-sm rounded-xs px-2"
          )}
        >
          <div className="flex w-full">
            <div className="flex items-center justify-center text-sm font-semibold w-5 mr-1 xs:mr-0 xs:w-8 shrink-0">
              {team.statistics?.position}.
            </div>

            {showLogos && (
              <div className="flex justify-center items-center ">
                <div className="flex justify-center items-center mr-2 xs:mr-3 w-6 rounded-sm h-6">
                  <img className="" src={team.logo} />
                </div>
              </div>
            )}

            <div className="flex w-full flex-col xs:flex-row my-2 mr-2 xs:mr-0 ">
              <div className=" w-full grid grid-flow-col items-center ">
                <span
                  className={classNames(
                    highlightedTeams.length &&
                      highlightedTeams.includes(team.id)
                      ? "font-semibold"
                      : "",
                    "truncate text-left"
                  )}
                >
                  {team.name}
                </span>
              </div>
              <TeamForm form={team?.statistics?.formList} />
            </div>
          </div>
          <div className="flex w-fit">
            <div className="flex w-full space-x-0.5  items-center justify-between sm:justify-around">
              {statsList}
            </div>
            <div className="flex flex-col justify-center ml-1 mr-2">
              <span className="flex justify-center w-7">
                <div
                  className={classNames(
                    highlightedTeams.length &&
                      highlightedTeams.includes(team.id)
                      ? "bg-gray-500 text-white"
                      : "bg-gray-200 text-black ",
                    "flex py-1 rounded-md justify-center items-center text-center w-full font-medium"
                  )}
                >
                  {team?.statistics?.points}
                </div>
              </span>
            </div>
          </div>
        </div>
      );
    });

  const header = (
    <div className="flex w-fit space-x-0.5  items-center justify-between sm:justify-around text-xs font-semibold  mr-2.5">
      <div className="text-center w-6 xs:w-8">Mp</div>
      <div className="text-center w-4 xs:w-6">W</div>
      <div className="text-center w-4 xs:w-6">D</div>
      <div className="text-center w-4 xs:w-6">L</div>
      <div className="text-center w-6 xs:w-8">Gs</div>
      <div className="text-center w-6 xs:w-8">Gc</div>
      <div className="text-center w-6 xs:w-8">Gd</div>
      <div className="text-center w-7">P</div>
    </div>
  );

  return (
    <>
      {!leagueTeams ? (
        <div className="flex flex-col">
          <SkeletonLoader type={"emptyTableRow"} amount={3} />
        </div>
      ) : (
        <div className="flex flex-col w-full bg-white rounded-md py-4 space-y-2">
          <div className="flex justify-end">{header}</div>
          <div className="flex flex-col space-y-1">{list}</div>
        </div>
      )}
    </>
  );
};

export default LeagueTable;
